<template>


    <div>
        <div v-if="is_super_admin">
            <div style="padding: 0px 16px;">
                <el-button plain type="primary" @click="sendMessageButtonFunc" size="small" icon="el-icon-plus">发送公共消息</el-button>
            </div>

            <div style="padding: 10px 16px;">
                <el-table
                    :data="messageList"
                    style="width: 100%;border-color:'#606266'"
                    :default-sort = "{prop: 'date', order: 'descending'}"
                    :header-cell-style="{background:'#f8f8f8', fontFamily:'Helvetica',fontSize:'14px'}"
                    :cell-style="{color: '#666',fontSize:'14px'}"
                    border
                    >
                    <el-table-column
                        fixed
                        align="center"
                        prop="message_id"
                        label="消息ID"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column
                        fixed
                        align="center"
                        prop="message_title"
                        label="消息标题"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column
                        fixed
                        align="center"
                        prop="message_content"
                        label="消息内容"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column
                        align="center"
                        label="操作"
                        width="100px"
                    >
                    <template slot-scope="scope">
                        <el-button round icon="el-icon-delete" type="danger" size="small" @click="deleteFunc(scope.row)">删除</el-button>
                    </template>
                    </el-table-column>

                </el-table>

                <el-pagination
                    @current-change="changeCurrent"
                    :current-page="iCurrentPage"
                    :page-size="10"
                    layout="total, prev, pager, next, jumper"
                    :total="iMaxTotal"
                    style="text-align:right; margin-top:15px"
                >
                </el-pagination>

            </div>

            
            <el-dialog :visible.sync="bShowDialog" :fullscreen="bShowFullscreen" :before-close="this.$dialog_close" :show-close="false">
                <div slot="title" class="dialog-title">
                    <span style="font-size: 18px; line-height: 24px; color: #303133;">{{ sDialogNmae }}</span>
                    <el-button icon="el-icon-close" class='dialog-title-button' @click="bShowDialog = false"></el-button>
                    <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="bShowFullscreen = !bShowFullscreen"></el-button>
                </div>

                <el-form :model="dFromData" ref="dFromData" labeel-width="100px" @class="demo-dFromData">
                    <el-form-item label="消息名称" prop="message_title" label-width="150px">
                        <el-input v-model="dFromData.message_title" ></el-input>
                    </el-form-item>

                    <el-form-item label="消息内容" prop="message_content" label-width="150px">
                        <el-input
                        type="textarea"
                        :autosize="{minRows: 2, maxRows: 15}"
                        placeholder="请输入内容"
                        v-model="dFromData.message_content">
                        </el-input>
                    </el-form-item>

                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="cancelFunc">取 消</el-button>
                    <el-button type="primary" @click="defineFunc">确 定</el-button>
                </div>

            </el-dialog>

        </div>

        <div v-else>
            <div style="text-align: center;">
                <div style="margin-top: 0px;">
                <img src="../assets/permission_denied.png">
                <div style="margin-top: 20px;">
                    <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MessageSystem",
    data(){
        return {
            bShowDialog: false,
            bShowFullscreen: false,
            sDialogNmae: '发送消息',

            dFromData: {
                message_title: '',
                message_content: '',
                message_type: 'public',
            },

            messageList: [],
            iCurrentPage: 1,
            iMaxTotal: 10,
            is_super_admin: false,
        }
    },

    mounted(){
        // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
        let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
        if (isSuperAdmin == "false") {
            this.is_super_admin = false
            return
        } else {
        this.is_super_admin = true
        }
        this.getMessageList();
    },

    methods: {
        // 发送消息事件
        async sendMessageButtonFunc(){
            this.bShowDialog = true
            this.bShowFullscreen = false
            this.dFromData = {
                message_title: '',
                message_content: '',
                message_type: 'public',
            }
        },

        // 取消事件
        cancelFunc(){
            this.bShowDialog = false
        },

        // 确定事件
        async defineFunc(){
            let res = await this.$axios.post('/api/message/', this.dFromData);
            this.requestWaring(res)
        },

        // 请求警告
        requestWaring(res){
            if (res.status === 201 || res.status === 200){
                this.$message({
                    message: '操作成功',
                    type: 'success'
            })
            this.bShowDialog = false
            this.getMessageList()
            
            } else {
                this.$message({
                    message: '操作失败',
                    type: 'error'
                })
            }
        },

        // 获取消息列表
        async getMessageList(){
            let d_params = {
                'page': this.iCurrentPage,
                'page_size': 10,
                'message_type': 'public',
            }
            const res = await this.$axios.get('/api/message/', {params: d_params});
            this.messageList = res.data.results;
            this.iMaxTotal = res.data.count;
        },

        // 分页事件
        changeCurrent(val){
            this.iCurrentPage = val;
            this.getMessageList();
        },

        // 删除事件
        deleteFunc(row){
            var _this = this
            this.$confirm('此操作将永久删除该消息', '删除消息警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                _this.$axios.delete('/api/message/' + row.message_id + '/').then(
                function(res){_this.$message({type: 'success',message: '删除成功!'});
                _this.getMessageList()})
            }).catch(() => {
                _this.$message({type: 'info',message: '已取消删除'});          
            });
        },
    }

}
</script>

<style>

</style>